import { useState } from "react";

type InitialValue<T> = T | (() => T);
export const useOptionalState = <T>(initialValue?: InitialValue<T>) => {
	const state = useState<T | undefined>(initialValue);

	return state;
};
